import React from 'react';
import { Navigate } from 'react-router-dom';
import PortalLayout from './PortalLayout';
import { useAuth } from '../../App';
import JumpstartStudio from '../../components/coaching/JumpstartStudio';

export default function CoachJumpstartSessions() {
  const { user } = useAuth();
  const isCoach = user?.is_coach === true || user?.role === 'coach';
  if (!isCoach) return <Navigate to="/portal" replace />;
  return (
    <PortalLayout active="jumpstart">
      <div data-testid="coach-jumpstart-page">
        <JumpstartStudio />
      </div>
    </PortalLayout>
  );
}
